<div class="spinner-wrapper" *ngIf="showLoader">
  <mat-spinner></mat-spinner>
</div>
<div class="container equipment-wrapper">
  <h2>Systems</h2>
  <hr />
  <div class="breadcrumb">
    <ul class="d-flex align-items-center breadcrumb__list">
      <li class="breadcrumb__list__list-item">
        <a class="breadcrumb__list__list-item__link" [routerLink]="['/home']">Home</a>
      </li>
      <li class="breadcrumb__list__list-item">
        <a class="breadcrumb__list__list-item__link" [routerLink]="['/system']">Systems</a>
      </li>
    </ul>
  </div>
  <form action="">
    <div class="input-wrapper">
      <mat-form-field appearance="fill" class="d-flex search-field">
        <mat-icon>search</mat-icon>
        <input matInput [(ngModel)]="searchSystem" name="search" placeholder="Placeholder" />
      </mat-form-field>
    </div>
  </form>
  <div class="d-flex justify-content-start">
    <button mat-flat-button color="primary" class="add-new-btn" [routerLink]="['/new-system']">
      <mat-icon>add</mat-icon> New System
    </button>
  </div>
  <div class="row">
    <div class="equipment-wrapper__item col-md-4 col-12 px-3 d-flex" *ngFor="let system of systems | appFilter: searchSystem;">
      <mat-card class="w-100 d-flex flex-column">
        <div class="flex-grow-1">
          <h2 class="equipment-wrapper__item__title">
            {{ system?.name }}
          </h2>
          <p class="equipment-wrapper__item__detail">
            <!-- ID: {{ system?.id }} -->
          <br>
          </p>
        </div>

        <span>
        <button class="w-100" mat-flat-button color="accent" [routerLink]="['/view-system']"
          [queryParams]="{ id: system.id }">
          View System
        </button>

      </span>

      </mat-card>
    </div>
  </div>
</div>
